import Cover from "../../components/cover/cover";
import Bookings from "../../components/bookings/bookings";
import { useLocation } from "react-router-dom";
import { getContainerClass } from "../../components/navigation/navigation";
// import Header from "../../components/header/header";
const BookingPage = () => {
  const breadcrumb = ["Home", "Bookings"];
  const location = useLocation();

  return (
    <>
      {/* <Header /> */}
      <div className={getContainerClass(location.pathname)}>
        <Cover breadcrumb={breadcrumb} page="bookings" />
        <div>
          <Bookings />
        </div>
      </div>
    </>
  );
};

export default BookingPage;
